import React from 'react';
import Button from '../common/Button';

const LoginButton = ({ onLogin, loading = false }) => {
  return (
    <Button
      onClick={onLogin}
      loading={loading}
      variant="primary"
      size="medium"
    >
      {loading ? 'Logging in...' : 'Login with Nextcloud'}
    </Button>
  );
};

export default LoginButton;